import { render, staticRenderFns } from "./VGoalImage.vue?vue&type=template&id=e8b81c4e&"
import script from "./VGoalImage.vue?vue&type=script&lang=js&"
export * from "./VGoalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports